import Immutable from 'immutable';
import * as types from './Order.types';

const initialState = {
    shipName: '',
    shipAddress1: '',
    shipAddress2: '',
    shipCity: '',
    shipState: 'Texas',
    shipZip: '',
    shipPhone: '',
    shipEmail: '',
    shipNotes: '',
    billName: '',
    billAddress1: '',
    billAddress2: '',
    billCity: '',
    billState: 'Texas',
    billZip: '',
    billPhone: '',
    billEmail: '',
    billPo: '',
    billDepartment: '',
    billCall: 0,
    billNotes: '',
    sameAddress: 0,
    cardNumber: '',
    nameOnCard: '',
    expirationMonth: '',
    expirationYear: '',
    securityNumber: '',
    referenceFiles: [],
    ordering: false,
    orderId: null,
    pdfUrl: null,
    pdfFilename: null,
    orderName: null,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.PLACE_ORDER:
            return state.setIn(['ordering'], true).toJS();

        case types.PLACE_ORDER_SUCCESS:
            return state.setIn(['ordering'], false).toJS();

        case types.PLACE_ORDER_ERROR:
            return state.setIn(['ordering'], false).toJS();

        case types.SET_SHIP_NAME:
            return state.setIn(['shipName'], action.payload).toJS();

        case types.SET_SHIP_ADDRESS_1:
            return state.setIn(['shipAddress1'], action.payload).toJS();

        case types.SET_SHIP_ADDRESS_2:
            return state.setIn(['shipAddress2'], action.payload).toJS();

        case types.SET_SHIP_CITY:
            return state.setIn(['shipCity'], action.payload).toJS();

        case types.SET_SHIP_STATE:
            return state.setIn(['shipState'], action.payload).toJS();

        case types.SET_SHIP_ZIP:
            return state.setIn(['shipZip'], action.payload).toJS();

        case types.SET_SHIP_PHONE:
            return state.setIn(['shipPhone'], action.payload).toJS();

        case types.SET_SHIP_EMAIL:
            return state.setIn(['shipEmail'], action.payload).toJS();

        case types.SET_SHIP_NOTES:
            return state.setIn(['shipNotes'], action.payload).toJS();

        case types.SET_BILL_NAME:
            return state.setIn(['billName'], action.payload).toJS();

        case types.SET_BILL_ADDRESS_1:
            return state.setIn(['billAddress1'], action.payload).toJS();

        case types.SET_BILL_ADDRESS_2:
            return state.setIn(['billAddress2'], action.payload).toJS();

        case types.SET_BILL_CITY:
            return state.setIn(['billCity'], action.payload).toJS();

        case types.SET_BILL_STATE:
            return state.setIn(['billState'], action.payload).toJS();

        case types.SET_BILL_ZIP:
            return state.setIn(['billZip'], action.payload).toJS();

        case types.SET_BILL_PHONE:
            return state.setIn(['billPhone'], action.payload).toJS();

        case types.SET_BILL_EMAIL:
            return state.setIn(['billEmail'], action.payload).toJS();

        case types.SET_BILL_PO:
            return state.setIn(['billPo'], action.payload).toJS();

        case types.SET_BILL_DEPARTMENT:
            return state.setIn(['billDepartment'], action.payload).toJS();

        case types.SET_BILL_CALL:
            return state.setIn(['billCall'], action.payload).toJS();

        case types.SET_BILL_NOTES:
            return state.setIn(['billNotes'], action.payload).toJS();

        case types.SET_SAME_ADDRESS:
            return state.setIn(['sameAddress'], action.payload).toJS();

        case types.SET_CARD_NUMBER:
            return state.setIn(['cardNumber'], action.payload).toJS();

        case types.SET_NAME_ON_CARD:
            return state.setIn(['nameOnCard'], action.payload).toJS();

        case types.SET_EXPIRATION_MONTH:
            return state.setIn(['expirationMonth'], action.payload).toJS();

        case types.SET_EXPIRATION_YEAR:
            return state.setIn(['expirationYear'], action.payload).toJS();

        case types.SET_SECURITY_NUMBER:
            return state.setIn(['securityNumber'], action.payload).toJS();

        case types.SET_REFERENCE_FILES:
            return state.setIn(['referenceFiles'], action.payload).toJS();

        case types.SET_ORDER_ID:
            return state.setIn(['orderId'], action.payload).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}